import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import * as moment from "moment";
import { CalendarModule } from "primeng/calendar";
import {
  API_URLS,
  FIRST_TEN_NUMBERS,
  MOMENT_FORMAT_START_DATE,
  P_CALENDAR_DATE_FORMAT,
} from "../../../../../config/app.constants";
import { HttpinterceptorService } from "../../../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../../../shared/utils";

@Component({
  selector: "app-boarding-filter",
  templateUrl: "./boarding-filter.component.html",
  styleUrls: ["./boarding-filter.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltip,
    NgSelectModule,
    FormsModule,
    CalendarModule,
  ],
})
export class BoardingFilterComponent implements OnInit {
  @ViewChild("checkout") checkout: any;

  inwardDate: Date;
  outwardDate: Date;
  selectedDateArray = [];
  petsList: any[] = [];
  numberOfPets = FIRST_TEN_NUMBERS;
  selectedPet: any;
  selectedPetSlug: any;
  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;
  petTypeObj = {};
  submitted: boolean = false;
  minInWardDate: Date;
  maxDate: Date;
  selectedPetNumber: number = 1;

  constructor(private http: HttpinterceptorService, private router: Router) {
    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;
  }

  ngOnInit() {
    this.minInWardDate = new Date();
    this.minInWardDate.setDate(this.minInWardDate.getDate() + 1); // Tomorrow Date
    this.minInWardDate.setHours(0, 0, 0, 0); // Set time to start of the day

    this.getPetTypes();
    // sessionStorage.removeItem("filterRanges");
  }

  getPetTypes() {
    this.http.post(API_URLS.PET_TYPES, {}, false).subscribe((response) => {
      this.petsList = [];
      if (response.type === "success") {
        if (response.data) {
          this.petTypeObj = response.data;
          for (let index in response.data) {
            this.petsList.push({ id: index, name: response.data[index] });
          }
          this.selectedPet = this.petsList[0].id;
          this.selectedPetSlug = this.petsList[0].name;
        }
      }
    });
  }

  checkCageAvailability() {
    this.selectedPetSlug = this.petTypeObj[this.selectedPet];
    this.submitted = true;
    if (this.inwardDate && this.outwardDate) {
      const dateRanges = {
        fromDate: this.inwardDate,
        toDate: this.outwardDate,
        totalPets: this.selectedPetNumber,
      };
      sessionStorage.removeItem("filterRanges");
      sessionStorage.filterRanges = JSON.stringify(dateRanges);
      this.router.navigate(["/boarding-service", this.selectedPetSlug]);
    } else {
      return false;
    }
  }

  selectInwardDate() {
    if (this.inwardDate) {
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      const expectedOutwardDate = this.addDays(this.inwardDate, 1);
      this.outwardDate = expectedOutwardDate;
      const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
      this.selectedDateArray.push(
        expectedOutward[0] + "/" + expectedOutward[1] + "/" + expectedOutward[2]
      );
      this.checkout.showOverlay(
        this.checkout.inputfieldViewChild.nativeElement
      );
    }
  }

  selectOutwardDate() {
    if (this.inwardDate) {
      const inwardDate = Utils.getDateFormat(this.inwardDate);
      const outwardDate = Utils.getDateFormat(this.outwardDate);
      const checkInDate =
        inwardDate[0] + "/" + inwardDate[1] + "/" + inwardDate[2];
      const checkoutDate =
        outwardDate[0] + "/" + outwardDate[1] + "/" + outwardDate[2];
      if (checkInDate == checkoutDate) {
        this.outwardDate = null;
        this.selectInwardDate();
        return false;
      } else {
        const checkinDiff = moment(checkInDate, MOMENT_FORMAT_START_DATE);
        const checkoutDiff = moment(checkoutDate, MOMENT_FORMAT_START_DATE);
        const totalDays = checkoutDiff.diff(checkinDiff, "days");
        this.selectedDateArray = [];
        const date = Utils.getDateFormat(this.inwardDate);
        this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
        for (let i = 1; i <= totalDays; i++) {
          const expectedOutwardDate = this.addDays(this.inwardDate, i);
          const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
          this.selectedDateArray.push(
            expectedOutward[0] +
              "/" +
              expectedOutward[1] +
              "/" +
              expectedOutward[2]
          );
        }
      }
    }
  }

  addDays(date, count) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + count);
    return newDate;
  }

  getSelectedDays(date) {
    const format = date.day + "/" + (date.month + 1) + "/" + date.year;
    return this.selectedDateArray.includes(format);
  }
}
